module.exports = __webpack_public_path__ + "img/category_sohvat_3-istuttavat.a7b59d47.webp";